import React, { useEffect, useState } from "react";
import * as S from "./styles";
import RoundInput from "@/components/RoundInput";
import { FutButton } from "@/components/FutButton";
import { useForm } from "react-hook-form";
import { api } from "@/services/api";
import { catchError } from "@/utils/catchError";
import { toast } from "react-toastify";

export default function Invoice() {
  const [commissionTBP, setCommissionTBP] = useState(-1);
  const [grossSales, setGrossSales] = useState(-1);
  const [cleanAmount, setCleanAmount] = useState(-1);

  useEffect(() => {
    const init = async () => {
      try {
        const commissions = await api.get("/report/commissionToBePaid");
        const amount = await api.get("/report/cleanAmount");
        const gross = await api.get("/report/grossSales");

        setCommissionTBP(Number(commissions.data.body));
        setCleanAmount(Number(amount.data.body));
        setGrossSales(Number(gross.data.body));
      } catch (e) {
        const message = catchError(e);
        if (message) {
          toast.error(message);
          return;
        }
        toast.error(e as any);
      }
    };
    init()
  }, []);

  return (
    <>
      <S.setyledText>Administrativo Futscore, Geral Movimentações</S.setyledText>
      <br />
      <S.GeralWrapper>
      <S.BubbleContainer>
        Comissões a ser paga:
        <br/>
        {/* <h1>{commissionTBP === -1 ? "Carregando..." : commissionTBP.toFixed(2)}</h1> */}
        <h1>R$995.742,40</h1>
      </S.BubbleContainer>
      <S.BubbleContainer>
        Valor Liquido:
        <br/>
       {/* <h1>{cleanAmount === -1 ? "Carregando..." : cleanAmount.toFixed(2)}</h1>  */}
       <h1>R$1.217.327,71</h1>
      </S.BubbleContainer>
      <S.BubbleContainer>
        Valor Bruto:
        <br/>
       {/* <h1>{grossSales === -1 ? "Carregando..." : grossSales.toFixed(2)}</h1>  */}
       <h1>R$2.213.323,11</h1>
      </S.BubbleContainer>
    </S.GeralWrapper>
    </>

  );
}
